import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import deepmerge from 'deepmerge';
import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
var globalStores = {};
var SINGLETON_STORE_ID = 'global';
var POPULATE_STORE = 'Store::Populate';
var INITIALIZE_STORE = '@beef/GetDefaults';
export { POPULATE_STORE, compose };

/**
 * Project wide typical redux store
 * has three arguments, neither of which are required
 */
function configureStore(rootReducer, extraMiddleware) {
  // eslint-disable-next-line no-underscore-dangle
  var composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(enableStorePopulation(rootReducer), composeEnhancers(applyMiddleware.apply(void 0, [thunk].concat(_toConsumableArray(extraMiddleware || [])))));
}

/**
 * enhance `rootReducer` for population: rewriting entire store with new incoming data
 */
var enableStorePopulation = function enableStorePopulation(rootReducer) {
  return function (state, action) {
    var type = action.type,
      payload = action.payload;
    if (type === POPULATE_STORE) {
      /** first fill initialState */
      var initialState = rootReducer(state, {
        type: INITIALIZE_STORE
      });
      /** then merge incoming data on top */
      state = deepmerge(initialState, payload, {
        arrayMerge: function arrayMerge(_, incoming) {
          return incoming;
        }
      });
    }
    return rootReducer(state, action);
  };
};
export var populateStore = function populateStore(payload) {
  return {
    type: POPULATE_STORE,
    payload: payload
  };
};
export function getStore() {
  var storeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SINGLETON_STORE_ID;
  if (!globalStores[storeId] || typeof window === 'undefined') {
    throw new Error('Attempting to retrieve store before initialization');
  }
  return globalStores[storeId];
}
function setStore(storeId, store) {
  globalStores[storeId] = store;
}
/**
 * The whole idea is that there should only be one store created.
 * We may replace rootReducer and that is about it
 */
export function composeStoreInitializer(rootReducer) {
  var middleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var storeId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SINGLETON_STORE_ID;
  return function initializeStore() {
    try {
      var store = getStore(storeId);
      store.replaceReducer(enableStorePopulation(rootReducer));
      return store;
    } catch (err) {
      var _store = configureStore(rootReducer, middleware);
      setStore(storeId, _store);
      return _store;
    }
  };
}